export const Permissions = {
  ABOUT_PROGRAMME_BAADSHAH: 'ABOUT_PROGRAMME_BAADSHAH',
  PROFILE_BAADSHAH: 'PROFILE_BAADSHAH',
  POINTS_DASHBOARD_BAADSHAH: 'POINTS_DASHBOARD_BAADSHAH',
  ADD_OFFTAKE_ENTRY: 'ADD_OFFTAKE_ENTRY',
  EDIT_OFFTAKE_ENTRY: 'EDIT_OFFTAKE_ENTRY',
  OFFTAKE_VERIFICATION_STATUS: 'OFFTAKE_VERIFICATION_STATUS',
  OFFTAKE_REPORT_BAADSHAH: 'OFFTAKE_REPORT_BAADSHAH',
  INVOICE_VERIFICATION: 'INVOICE_VERIFICATION',
  INDIRECT_BILLING_REPORT: 'INDIRECT_BILLING_REPORT',
  FLEET_DETAIL: 'FLEET_DETAIL',
  WHATS_NEW_BAADSHAH: 'WHATS_NEW_BAADSHAH',
  CONTACT_US_BAADSHAH: 'CONTACT_US_BAADSHAH',
  SALES_REPORT: 'SALES_REPORT',
  MEMBER_SALE_DETAIL: 'MEMBER_SALE_DETAIL',
  TARGET_SALES: 'TARGET_SALES',
  ENROLL_FLEET: 'ENROLL_FLEET',
  NEW_FLEET_REGISTRATION: 'NEW_FLEET_REGISTRATION',
  ACTIVITY_REPORT: 'ACTIVITY_REPORT',
  SET_ACTIVITY_TARGET: 'SET_ACTIVITY_TARGET',
  SPECIAL_ENGAGEMENT: 'SPECIAL_ENGAGEMENT',
  OFFTAKE_DASHBOARD_BAADSHAH: 'OFFTAKE_DASHBOARD_BAADSHAH',
  REDEMPTION_CATALOGUE: 'REDEMPTION_CATALOGUE',
  DOWNLOAD_SCORECARD_BAADSHAH: 'DOWNLOAD_SCORECARD_BAADSHAH',
  DOWNLOAD_FLEET_MASTER: 'DOWNLOAD_FLEET_MASTER',
  PRIMARY_POINTS_REDEMPTION: 'PRIMARY_POINTS_REDEMPTION',
  CUSTOMER_INTERACTION: 'CUSTOMER_INTERACTION',
  UPDATE_ORDER_STATUS: 'update_redemption_status',
  UPLOAD_CN_DETAILS: 'UPLOAD_CN_DETAILS',
}